// Port of api/fuel/app/classes/filter/search/games/filters/query/rating/unrated.php
export default {
	name: 'rating.unrated',
	priority: 60,
	require: function(config, filter) {
		return filter.unrated === 1
	},
	run: function(config, filter, data, query) {
		query.notexist('rating', 'rn')
	}
}
